function getUrlWithToken(url: string): string {
  const token = crypto.randomUUID().replace(/-/g, '').slice(0, 12);
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}token=${token}`;
}

export default getUrlWithToken;
